import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWarningCompliance = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M465.030 716.8h111.19v102.4h-111.19v-102.4zM465.030 307.2h111.19v307.2h-111.19v-307.2zM909.783 102.4h-232.381c-23.352-59.392-84.506-102.4-156.78-102.4-72.27 0-133.424 43.008-156.774 102.4h-232.385c-7.783 0-15.010 0.512-22.238 2.048-21.682 4.096-41.14 14.336-56.151 28.16-10.007 9.216-18.346 20.48-23.905 32.768-5.559 11.776-8.895 25.088-8.895 39.424v716.8c0 13.824 3.336 27.648 8.895 39.936s13.899 23.040 23.905 32.768c15.011 13.824 34.469 24.064 56.151 28.16 7.227 1.024 14.455 1.536 22.238 1.536h778.319c61.158 0 111.191-46.080 111.191-102.4v-716.8c0-56.32-50.033-102.4-111.191-102.4zM520.622 89.6c22.794 0 41.697 17.408 41.697 38.4s-18.903 38.4-41.697 38.4c-22.791 0-41.693-17.408-41.693-38.4s18.902-38.4 41.693-38.4zM909.783 921.6h-778.319v-716.8h778.319v716.8z",
		fill: "rgb(47, 128, 237)"
	})
});
const ForwardRef = forwardRef(SvgWarningCompliance);
export default ForwardRef;
